import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {Moment} from "moment";
import {ItemInfo} from "../item-info";

type Data = { chartData: any[], canSend: boolean, columns: ColumnSettingsBase[] };
export class ChartDataTabInfo extends TabInfoBase<Data> {
    constructor(type: string, data: Data, itemInfo: ItemInfo, startDate: Moment, endDate: Moment, sharedGuid: string) {
        super('ChartData', type, data, itemInfo, startDate, endDate, sharedGuid);
    }

    get id(): string {
        return ChartDataTabInfo.id;
    }

    static readonly id = 'CD';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-data/chart-data-tab-info.ts